import createAction from "../../lib/createAction";

export const RESET_FORM = "RESET_FORM";
export const resetForm = createAction(RESET_FORM, "id");

export const AFTER_RESET_FORM = "AFTER_RESET_FORM";
export const afterResetForm = createAction(AFTER_RESET_FORM, "id");
